export default function HeroSection() {
  return (
    <section
      id="hero"
      className="relative pt-[72px] overflow-hidden min-h-[620px] md:min-h-[680px] flex items-center"
    >
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20cinema%20atmosphere%20with%20soft%20bed%20and%20cozy%20blankets%2C%20golden%20ambient%20lighting%2C%20movie%20projector%20beam%20casting%20warm%20glow%2C%20abstract%20artistic%20style%20with%20rich%20amber%20and%20warm%20brown%20tones%2C%20dreamy%20cinematic%20mood%2C%20soft%20bokeh%20effects%2C%20elegant%20composition%2C%20warm%20color%20gradient%20background&width=1800&height=1200&seq=hero-bg-beiwo-01&orientation=landscape"
          alt="被窝影院 - 温暖观影氛围"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-black/55"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto">
          <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
            <div className="flex-1 w-full text-center lg:text-left">
              <div className="flex flex-wrap items-center gap-2 justify-center lg:justify-start mb-4">
                <span className="px-3 py-1 text-xs font-medium bg-primary-500/20 text-primary-300 border border-primary-500/30 rounded-full whitespace-nowrap">
                  最新地址首页直达
                </span>
                <span className="px-3 py-1 text-xs font-medium bg-accent-500/20 text-accent-300 border border-accent-500/30 rounded-full whitespace-nowrap">
                  安全便捷观影
                </span>
                <span className="px-3 py-1 text-xs font-medium bg-background-50/10 text-background-50/80 border border-background-50/20 rounded-full whitespace-nowrap">
                  每日更新
                </span>
              </div>

              <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-background-50 font-heading leading-tight mb-3">
                被窝影院
                <span className="block text-xl md:text-2xl lg:text-3xl font-normal mt-2 text-primary-300">
                  高清电影电视剧免费在线观看
                </span>
              </h1>

              <p className="text-sm md:text-base text-background-50/75 font-medium mt-2 mb-4 max-w-lg mx-auto lg:mx-0">
                躺进被窝，畅享万千精彩 — 不止观影，更是放松。
              </p>

              <div className="max-w-xl mx-auto lg:mx-0">
                <p className="text-sm text-background-50/70 leading-relaxed mb-3">
                  被窝影院官网为您打造一站式高清影视体验，无需注册即可免费在线观看海量电影电视剧。本站覆盖动作、喜剧、爱情、悬疑、科幻、动漫等多种类型，从热播新片到经典老剧一应俱全。每日滚动更新最新资源，高清画质流畅不缓冲，支持多设备观看。最新地址首页直达，安全无广告干扰，让您随时随地享受纯粹的追剧时光。
                </p>
                <p className="text-sm text-background-50/70 leading-relaxed mb-5">
                  当前热推：近期院线新片陆续上线，热门国产剧与海外剧同步更新，欢迎大家收藏本站，随时回来刷剧。
                </p>
              </div>

              <div className="flex flex-wrap items-center gap-4 md:gap-8 justify-center lg:justify-start mb-6">
                <div className="text-center">
                  <div className="text-xl md:text-2xl font-bold text-accent-400 font-heading">20000+</div>
                  <div className="text-xs text-background-50/60 mt-1">影视资源</div>
                </div>
                <div className="w-px h-8 bg-background-50/20 hidden sm:block"></div>
                <div className="text-center">
                  <div className="text-xl md:text-2xl font-bold text-accent-400 font-heading">每日更新</div>
                  <div className="text-xs text-background-50/60 mt-1">内容持续上新</div>
                </div>
                <div className="w-px h-8 bg-background-50/20 hidden sm:block"></div>
                <div className="text-center">
                  <div className="text-xl md:text-2xl font-bold text-accent-400 font-heading">高清流畅</div>
                  <div className="text-xs text-background-50/60 mt-1">不缓冲不卡顿</div>
                </div>
              </div>

              <div className="flex flex-col sm:flex-row items-center gap-3 justify-center lg:justify-start">
                <a
                  href="#media"
                  className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold text-sm rounded-full transition-all whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-play-circle-line text-lg"></i>
                  立即观看
                </a>
                <a
                  href="#app"
                  className="inline-flex items-center gap-2 px-6 py-3 bg-background-50/10 hover:bg-background-50/20 text-background-50 font-semibold text-sm rounded-full border border-background-50/30 transition-all whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-download-2-line text-lg"></i>
                  下载APP
                </a>
              </div>
            </div>

            <div className="flex-shrink-0 w-full max-w-[420px] lg:max-w-[460px] hidden sm:block">
              <div className="relative rounded-2xl overflow-hidden aspect-[4/5] bg-background-50/5 border border-background-50/10">
                <img
                  src="https://readdy.ai/api/search-image?query=Cozy%20bedroom%20scene%20with%20a%20large%20floating%20screen%20showing%20cinematic%20movie%20imagery%2C%20warm%20blankets%20and%20pillows%2C%20soft%20golden%20ambient%20light%2C%20dreamy%20atmosphere%2C%20popcorn%20on%20a%20wooden%20tray%2C%20artistic%20illustration%20style%2C%20rich%20warm%20amber%20and%20cream%20tones%2C%20cinematic%20wide%20shot%2C%20elegant%20composition&width=920&height=1150&seq=hero-visual-beiwo-01&orientation=portrait"
                  alt="被窝影院 - 舒适观影体验"
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
                <div className="absolute bottom-4 left-4 right-4">
                  <div className="flex items-center gap-2 text-background-50/90 text-xs">
                    <div className="w-2 h-2 rounded-full bg-accent-500 animate-pulse"></div>
                    <span>每日更新中</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}